exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert-container[data-v-c8542b3a] {\n  position: fixed;\n  z-index: 10;\n}\np[data-v-c8542b3a]{\n  margin-bottom: 0;\n}\n", ""]);

// exports
